import * as React from 'react';
import styled from 'styled-components';

import DetailsOfRetrieval from './DetailsOfRetrieval';
import FamilyPlanningCalculator from './FamilyPlanningCalculator';
import { RetrievalResult } from './types';
import { Row, Column } from '../../../styled/Grid';
import { Title } from '../styled';

type Props = {
  retrievalResult: RetrievalResult;
};

const EggRetrieval = (props: Props) => {
  const { retrievalResult } = props;
  const { attemptType, attemptCompleted } = retrievalResult;

  const title = getTitle(attemptType, attemptCompleted);

  return (
    <Section>
      <Title>{title}</Title>
      <Row>
        <Column mobile={12} desktop={8}>
          <DetailsOfRetrieval {...retrievalResult} />
        </Column>
        <Column mobile={12} desktop={4}>
          <FamilyPlanningCalculator />
        </Column>
      </Row>
    </Section>
  );
};

export const getTitle = (attemptType: string, attemptCompleted: boolean) => {
  return attemptType === 'egg_freezing'
    ? 'Current egg retrieval'
    : 'Current egg retrieval & fertilization';
};

const Section = styled.section`
  background-color: ${({ theme }) => theme.colors.night};
  padding-top: 10px;
`;

export default EggRetrieval;
